/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель информации о временном интервале доставки
   */
  app.DeliveryInterval = app.Model.extend({
    
    set: function (key, val, options) {
      
      if (key === null) {
        return this;
      }
      
      val = this.filter(key, val);
      
      if (typeof key === 'object') {
        for (var i in key) {
          if (key.hasOwnProperty(i)) {
            key[i] = this.filter(i, key[i]);
          }
        }
      }
      return app.Model.prototype.set.apply(this, [key, val, options]);
    },
    
    /**
     * Фильтрует поля времени, убирая секунды.
     * @param key Ключ поля
     * @param val Значение
     * @returns {String}
     */
    filter: function (key, val) {
      if (['time_from', 'time_to'].indexOf(key) !== -1) {
        val = this.removeNulls(val);
      }
      return val;
    },
    
    /**
     * Убирает секунды из времени.
     * @param val Исходное значение
     * @returns {String}
     */
    removeNulls: function (val) {
      if (typeof val === 'string') {
        var valArray = val.split(':');
        if (valArray.length === 3) {
          valArray = valArray.slice(0, 2);
        }
        val = valArray.join(':');
      }
      return val;
    }
  });
})();

}.call(window));